import { render, staticRenderFns } from "./waybill_detail.vue?vue&type=template&id=37e072a0&scoped=true&"
import script from "./waybill_detail.vue?vue&type=script&lang=js&"
export * from "./waybill_detail.vue?vue&type=script&lang=js&"
import style0 from "./waybill_detail.vue?vue&type=style&index=0&id=37e072a0&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e072a0",
  null
  
)

export default component.exports